import { render, staticRenderFns } from "./AppCadastroTreinador.vue?vue&type=template&id=06a4238b&"
import script from "./AppCadastroTreinador.vue?vue&type=script&lang=js&"
export * from "./AppCadastroTreinador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports